module.exports = __webpack_public_path__ + "media/alert_sound3.5d4bfc60.mp3";